import { render } from "./dui_detail.vue?vue&type=template&id=88c67c04"
import script from "./dui_detail.vue?vue&type=script&lang=js"
export * from "./dui_detail.vue?vue&type=script&lang=js"

import exportComponent from "E:\\zhaojiaming\\smz2023\\fashengren\\speaker_h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__